import type { MemberAttributeFilterConfig } from "../components/MemberAttributeFilters";

export const FILTER_PRESETS = {
	memberBrowse: {
		layout: "grid",
		showDividers: false,
		showHelpText: true,
		enableAnimation: true,
		placeholderPattern: "input",
		gridColumns: {
			xs: 24,
			md: 12,
			lg: 6,
			xl: 6,
		},
	} as MemberAttributeFilterConfig,

	audienceSelection: {
		layout: "vertical",
		showDividers: true,
		showHelpText: false,
		enableAnimation: false,
		placeholderPattern: "search",
	} as MemberAttributeFilterConfig,

	sidebarFilter: {
		layout: "vertical",
		showDividers: false,
		showHelpText: true,
		enableAnimation: false,
		placeholderPattern: "search",
	} as MemberAttributeFilterConfig,
};
